import { render, staticRenderFns } from "./EditUserFormCerts.vue?vue&type=template&id=19954f8b&"
import script from "./EditUserFormCerts.vue?vue&type=script&lang=js&"
export * from "./EditUserFormCerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports